import { store } from './index'
import { userStatus, seasonObjectTypes, gameEventTypes, gameProgress, endSearchString, caseFoldNormalize } from '../constants'
import { db, fieldValue } from '../config'
const batchSize = 100

// firebase collections
const userCollection = db.collection('user')
const seasonCollection = db.collection('season')
const broadcastCollection = db.collection('broadcast')

export function setUserStatus (userId, status) {
  return new Promise((resolve, reject) => {
    let currentStatus = {
      status: {
        state: 0,
        last_changed: fieldValue.serverTimestamp()
      }
    }
    let userStatusDBRef = userCollection.doc(userId)

    switch (status) {
      case userStatus.offline:
      case userStatus.online:
        currentStatus.status.state = status
        userStatusDBRef.set(currentStatus, {merge: true}).then(() => {
          resolve()
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_setUserStatus_set failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      default:
        let newError = Error('Error Db_CloudFirestore_setUserStatus_unexpected status:' + status)
        console.log(newError.message)
        reject(newError)
        break
    }
  })
}

export function getUser (userId) {
  return new Promise((resolve, reject) => {
    let user = {}
    userCollection.doc(userId).get().then(docSnapshot => {
      if (docSnapshot.exists) {
        user = docSnapshot.data()
        if (user.hasOwnProperty('name') && !user.hasOwnProperty('name_casefold')) {
          user.name_casefold = caseFoldNormalize(user.name)
          updateUser(userId, user)
        }
      }
      resolve(user)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getUser_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function deleteUserName (userId) {
  return new Promise((resolve, reject) => {
    userCollection.doc(userId).update({
      name: fieldValue.delete()
    }).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_deleteUserName_update failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function updateUser (userId, user) {
  return new Promise((resolve, reject) => {
    if (user.hasOwnProperty('name')) {
      user.name_casefold = caseFoldNormalize(user.name)
    }
    userCollection.doc(userId).set(user, { merge: true }).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateUser_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function addSeasonPlayer (userId, seasonId, playerId, player) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('players').doc(playerId).set(player).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_addSeasonPlayer_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function incrementSeasonMaxId (userId, seasonId, type, scheduleId = null, gameId = null, eventType = null) {
  return new Promise((resolve, reject) => {
    let seasonRef = seasonCollection.doc(seasonId)
    let increment = fieldValue.increment(1)
    switch (type) {
      case seasonObjectTypes.player:
        seasonRef.update({ p: increment }).then(() => {
          seasonRef.get().then(docSnapshot => {
            let newDoc = {}
            if (docSnapshot.exists) {
              newDoc = docSnapshot.data()
              resolve('p' + newDoc.p)
            } else {
              let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_player failed: season doc does not exist')
              console.log(newError.message)
              reject(newError)
            }
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_player_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_player_increment failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      case seasonObjectTypes.game:
        seasonRef.update({ g: increment }).then(() => {
          seasonRef.get().then(docSnapshot => {
            let newDoc = {}
            if (docSnapshot.exists) {
              newDoc = docSnapshot.data()
              resolve('g' + newDoc.g)
            } else {
              let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_game failed: season doc does not exist')
              console.log(newError.message)
              reject(newError)
            }
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_game_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_game_increment failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      case seasonObjectTypes.schedule:
        seasonRef.update({ s: increment }).then(() => {
          seasonRef.get().then(docSnapshot => {
            let newDoc = {}
            if (docSnapshot.exists) {
              newDoc = docSnapshot.data()
              resolve('s' + newDoc.s)
            } else {
              let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_schedule failed: season doc does not exist')
              console.log(newError.message)
              reject(newError)
            }
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_schedule_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_schedule_increment failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      case seasonObjectTypes.level:
        seasonRef.collection('schedules').doc(scheduleId).update({ l: increment }).then(() => {
          seasonRef.collection('schedules').doc(scheduleId).get().then(docSnapshot => {
            let newDoc = {}
            if (docSnapshot.exists) {
              newDoc = docSnapshot.data()
              resolve('l' + newDoc.l)
            } else {
              let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_level failed: schedule doc does not exist')
              console.log(newError.message)
              reject(newError)
            }
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_level_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_level_increment failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      case seasonObjectTypes.event:
      case seasonObjectTypes.timerEvent:
        seasonRef.collection('games').doc(gameId).update({ e: increment }).then(() => {
          seasonRef.collection('games').doc(gameId).get().then(docSnapshot => {
            let newDoc = {}
            if (docSnapshot.exists) {
              let gameDoc = docSnapshot.data()
              // newDoc.e = gameDoc.e
              // let broadcast = ''
              // if (gameDoc.hasOwnProperty('b') && gameDoc.b !== '') {
              //   broadcast = gameDoc.b
              // }
              switch (eventType) {
                case gameEventTypes.created:
                  newDoc.p = gameProgress.created
                  break
                case gameEventTypes.finished:
                  newDoc.p = gameProgress.finished
                  break
                default:
                  if (!gameDoc.hasOwnProperty('p') || gameDoc.p !== gameProgress.in_progress) {
                    newDoc.p = gameProgress.in_progress
                  }
                  break
              }
              if (newDoc.hasOwnProperty('p')) {
                seasonRef.collection('games').doc(gameId).set(newDoc, { merge: true }).then(() => {
                  resolve('e' + gameDoc.e)
                }).catch(err => {
                  let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event_set failed: ' + err.message)
                  console.log(newError.message)
                  reject(newError)
                })
              } else {
                resolve(resolve('e' + gameDoc.e))
              }
              // seasonRef.collection('games').doc(gameId).set(newDoc, { merge: true }).then(() => {
              //   // if (broadcast !== '') {
              //   //   delete newDoc.b
              //   //   broadcastCollection.doc(broadcast).set(newDoc, { merge: true }).then(() => {
              //   //     resolve('e' + newDoc.e)
              //   //   }).catch(err => {
              //   //     let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event_broadcast.set failed: ' + err.message)
              //   //     console.log(newError.message)
              //   //     reject(newError)
              //   //   })
              //   // } else {
              //     resolve('e' + newDoc.e)
              //   // }
              // }).catch(err => {
              //   let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event_set failed: ' + err.message)
              //   console.log(newError.message)
              //   reject(newError)
              // })
            } else {
              let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event failed: game doc does not exist')
              console.log(newError.message)
              reject(newError)
            }
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId_event_increment failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
        break
      default:
        let newError = Error('Error Db_CloudFirestore_incrementSeasonMaxId failed: type not recognized')
        console.log(newError.message)
        reject(newError)
        break
    }
  })
}

export function updateSeasonPlayer (userId, seasonId, playerId, player) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('players').doc(playerId).set(player).then(() => {
      resolve(playerId)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateSeasonPlayer_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function deleteSeasonPlayer (userId, seasonId, playerId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('players').doc(playerId).delete().then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_deleteSeasonPlayer_delete failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function deleteSeasonStatistics (userId, seasonId, statisticId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('statistics').doc(statisticId).delete().then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_deleteSeasonStatistics_delete failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function deleteGameEvent (userId, seasonId, gameId, eventId, broadcast) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('games').doc(gameId).collection('events').doc(eventId).delete().then(() => {
      if (broadcast !== '') {
        broadcastCollection.doc(broadcast).collection('events').doc(eventId).delete().then(() => {
          resolve(eventId)
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_deleteGameEvent_broadcast_delete failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      } else {
        resolve(eventId)
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_deleteGameEvent_delete failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createSeasonSnapshot (userId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.where('roles.' + userId, '==', 'owner').onSnapshot(async querySnapshot => {
      let seasons = []
      let readers = store.state.shared.readers
      let readersChanged = false
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let season = doc.data()
        season.id = doc.id
        season.readers = {}
        for (const [roleId, role] of Object.entries(season.roles)) {
          if (role === 'reader') {
            if (!readers.hasOwnProperty(roleId)) {
              await getUser(roleId).then(user => {
                readers[roleId] = user.name
                readersChanged = true
              })
            }
            season.readers[roleId] = readers[roleId]
          }
        }
        seasons.push(season)
      }
      if (readersChanged) {
        store.dispatch('setSharedReaders', readers)
      }
      seasons.sort(function (a, b) {
        var nameA = a.n.toUpperCase()
        var nameB = b.n.toUpperCase()

        if (nameA < nameB) {
          return -1
        }

        if (nameA > nameB) {
          return 1
        }

        return 0
      })
      store.dispatch('setSeasons', seasons)
    })
    resolve(snapshot)
  })
}

export function createSharedSeasonSnapshot (userId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.where('roles.' + userId, '==', 'reader').onSnapshot(async querySnapshot => {
      let seasons = []
      let owners = store.state.shared.owners
      let ownersChanged = false
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let season = doc.data()
        season.id = doc.id
        for (const [roleId, role] of Object.entries(season.roles)) {
          if (role === 'owner') {
            if (!owners.hasOwnProperty(roleId)) {
              await getUser(roleId).then(user => {
                owners[roleId] = user.name
                ownersChanged = true
              })
            }
            season.owner = owners[roleId]
            break
          }
        }
        seasons.push(season)
      }
      if (ownersChanged) {
        store.dispatch('setSharedOwners', owners)
      }
      let sortBy = [{
        prop: 'owner',
        direction: 1
      }, {
        prop: 'n',
        direction: 1
      }]
      seasons.sort(function (a, b) {
        let i = 0
        let result = 0
        while (i < sortBy.length && result === 0) {
          result = sortBy[i].direction * (a[sortBy[i].prop].toString().toUpperCase() < b[sortBy[i].prop].toString().toUpperCase() ? -1 : (a[sortBy[i].prop].toString().toUpperCase() > b[sortBy[i].prop].toString().toUpperCase() ? 1 : 0))
          i++
        }
        return result
      })
      store.dispatch('setSharedSeasons', seasons)
    })
    resolve(snapshot)
  })
}

export function deleteSeasonReader (readerId, seasonId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).get().then(doc => {
      let data = doc.data()
      for (var property in data) {
        if (property !== 'roles') {
          delete data[property]
        }
      }
      if (data.roles.hasOwnProperty(readerId) && data.roles[readerId] === 'reader') {
        delete data.roles[readerId]
        seasonCollection.doc(seasonId).update(data).then(
          resolve(true)
        ).catch(err => {
          let newError = Error('Error Db_CloudFirestore_deleteSeasonReader_set failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      } else {
        resolve(false)
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_deleteSeasonReader_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getPreviousVersionSeasonList (userId) {
  return new Promise((resolve, reject) => {
    userCollection.doc(userId).collection('seasons').orderBy('n').get().then(querySnapshot => {
      let seasons = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i].data()
        let season = {}
        season.n = doc.n
        season.id = querySnapshot.docs[i].id
        seasons.push(season)
      }
      resolve(seasons)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getPreviousVersonSeasonList_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createSeasonPlayersSnapshot (userId, seasonId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('players').orderBy('n').onSnapshot(querySnapshot => {
      let players = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let player = doc.data()
        player.id = doc.id
        players.push(player)
      }
      store.dispatch('setSeasonPlayers', players)
    })
    resolve(snapshot)
  })
}

export function createSeasonSchedulesSnapshot (userId, seasonId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('schedules').orderBy('n').onSnapshot(querySnapshot => {
      let schedules = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let schedule = doc.data()
        schedule.id = doc.id
        schedules.push(schedule)
      }
      store.dispatch('setSeasonSchedules', schedules)
    })
    resolve(snapshot)
  })
}

export function createSeasonStatsSnapshot (userId, seasonId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('statistics').onSnapshot(querySnapshot => {
      let stats = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let stat = doc.data()
        stat.gameId = doc.id
        stats.push(stat)
      }
      store.dispatch('setSeasonStatistics', stats)
    })
    resolve(snapshot)
  })
}

export function createSeasonGamesSnapshot (userId, seasonId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('games').orderBy('d').onSnapshot(querySnapshot => {
      let games = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let game = doc.data()
        game.id = doc.id
        games.push(game)
      }
      store.dispatch('setSeasonGames', games)
    })
    resolve(snapshot)
  })
}

export function createGameGamesSnapshot (userId, seasonId, seasonName) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('games').orderBy('d').onSnapshot(querySnapshot => {
      let games = []
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let game = {}
        game.id = doc.id
        game.seasonId = seasonId
        game.seasonName = seasonName
        game.d = doc.data().d
        games.push(game)
      }
      store.dispatch('setGameGames', games)
    })
    resolve(snapshot)
  })
}

export function createGameEventsSnapshot (userId, seasonId, gameId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('games').doc(gameId).collection('events').orderBy('o').onSnapshot(querySnapshot => {
      let docChanges = querySnapshot.docChanges()
      store.dispatch('gameEventSnapshotChange', docChanges)
    })
    resolve(snapshot)
  })
}

export function createGameTimerGameSnapshot (userId, seasonId, gameId) {
  return new Promise((resolve, reject) => {
    let snapshot = seasonCollection.doc(seasonId).collection('games').doc(gameId).onSnapshot(doc => {
      let data = doc.data()
      store.dispatch('gameTimerSnapshotChange', data)
    })
    resolve(snapshot)
  })
}

export function getSeasonScheduleLevels (userId, seasonId, scheduleId) {
  return new Promise((resolve, reject) => {
    var levels = []
    seasonCollection.doc(seasonId).collection('schedules').doc(scheduleId).collection('levels').orderBy('o').get().then(querySnapshot => {
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        let level = doc.data()
        level.id = doc.id
        levels.push(level)
      }
      resolve(levels)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonScheduleLevels_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function updateSeasonSchedule (userId, seasonId, scheduleId, scheduleUpdate) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('schedules').doc(scheduleId).set(scheduleUpdate, { merge: true }).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateSeasonSchedule_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function updateSeasonScheduleLevels (userId, seasonId, scheduleId, scheduleUpdate) {
  return new Promise(async (resolve, reject) => {
    var batchUpdate = db.batch()

    let levelsUpdated = scheduleUpdate.levelsUpdated
    Object.keys(levelsUpdated).forEach(levelId => {
      let levelRef = seasonCollection
        .doc(seasonId)
        .collection('schedules')
        .doc(scheduleId)
        .collection('levels')
        .doc(levelId)
      batchUpdate.set(levelRef, levelsUpdated[levelId], { merge: true })
    })

    let levelsAdded = scheduleUpdate.levelsAdded
    for (let index = 0; index < levelsAdded.length; index++) {
      const level = levelsAdded[index]
      await store.dispatch('seasonIncreaseMaxId', { seasonId: seasonId, type: seasonObjectTypes.level, scheduleId: scheduleId }).then(levelId => {
        let levelRef = seasonCollection
          .doc(seasonId)
          .collection('schedules')
          .doc(scheduleId)
          .collection('levels')
          .doc(levelId)
        batchUpdate.set(levelRef, level)
      })
    }

    let levelsDeleted = scheduleUpdate.levelsDeleted
    levelsDeleted.forEach(levelId => {
      let levelRef = seasonCollection
        .doc(seasonId)
        .collection('schedules')
        .doc(scheduleId)
        .collection('levels')
        .doc(levelId)
      batchUpdate.delete(levelRef)
    })

    batchUpdate.commit().then(
      resolve()
    ).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateSeasonScheduleLevels_commit failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function deleteSeasonSchedule (userId, seasonId, scheduleId) {
  return new Promise((resolve, reject) => {
    // delete all levels
    var scheduleRef = seasonCollection
      .doc(seasonId)
      .collection('schedules')
      .doc(scheduleId)

    var levelsRef = scheduleRef
      .collection('levels')

    deleteCollection(levelsRef, batchSize).then(() => {
      // delete schedule
      scheduleRef.delete().then(() => {
        resolve()
      }).catch(err => {
        let newError = null
        if (err.hasOwnProperty('err')) {
          newError = Error('Error Db_CloudFirestore_deleteSeasonSchedule_delete failed: ' + err.err.message)
        } else {
          newError = Error('Error Db_CloudFirestore_deleteSeasonSchedule_delete failed: ' + err.message)
        }
        console.log(newError.message)
        reject(newError)
      })
    })
  })
}
export function deleteSeasonGame (userId, seasonId, gameId) {
  return new Promise((resolve, reject) => {
    var gameUndoDoc = {}
    // delete all events
    var gameRef = seasonCollection
      .doc(seasonId)
      .collection('games')
      .doc(gameId)

    var eventRef = gameRef
      .collection('events')

    gameRef.get().then(doc => {
      if (doc.exists) {
        let gameData = doc.data()
        gameUndoDoc = JSON.parse(JSON.stringify(gameData))
        gameUndoDoc.id = doc.id
        gameUndoDoc.events = []
        // delete game events
        deleteCollection(eventRef).then(eventsUndo => {
          // delete game
          gameUndoDoc.events = eventsUndo
          gameRef.delete().then(() => {
            if (gameData.b !== '') {
              broadcastCollection.doc(gameData.b).update({deleting: true}).then(() => {
                deleteCollection(broadcastCollection.doc(gameData.b).collection('events')).then(() => {
                  broadcastCollection.doc(gameData.b).delete().then(() => {
                    resolve(gameUndoDoc)
                  }).catch(err => {
                    gameUndoDoc.err = err
                    reject(gameUndoDoc)
                  })
                }).catch(err => {
                  gameUndoDoc.err = err
                  reject(gameUndoDoc)
                })
              })
            } else {
              resolve(gameUndoDoc)
            }
          }).catch(err => {
            gameUndoDoc.err = err
            reject(gameUndoDoc)
          })
        }).catch(eventUndoErr => {
          if (eventUndoErr.hasOwnProperty('err')) {
            let err = eventUndoErr.err
            delete eventUndoErr.err
            gameUndoDoc.events = eventUndoErr
            gameUndoDoc.err = err
          } else {
            gameUndoDoc.events = []
            gameUndoDoc.err = eventUndoErr
          }
          reject(gameUndoDoc)
        })
      } else {
        gameUndoDoc.id = -1
        gameUndoDoc.err = Error('Game to delete does not exist')
        reject(gameUndoDoc)
      }
    }).catch(err => {
      gameUndoDoc.err = err
      reject(gameUndoDoc)
    })
  })
}

export function deleteSeason (userId, seasonId) {
  return new Promise(async (resolve, reject) => {
    var seasonUndoDoc = {}
    var seasonRef = seasonCollection.doc(seasonId)

    // delete all games
    seasonUndoDoc.games = []
    seasonRef.collection('games').get().then(async querySnapshot => {
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        await deleteSeasonGame(userId, seasonId, doc.id).then(deletedGameDoc => {
          seasonUndoDoc.games.push(deletedGameDoc)
        }).catch(gameUndoErr => {
          // add rollback functionality
          seasonUndoDoc.err = gameUndoErr.err
          delete gameUndoErr.err
          seasonUndoDoc.games.push(gameUndoErr)
          reject(seasonUndoDoc)
        })
      }
      // delete all players
      seasonUndoDoc.players = []
      seasonRef.collection('players').get().then(async querySnapshot => {
        for (let i = 0; i < querySnapshot.docs.length; i++) {
          const doc = querySnapshot.docs[i]
          await deleteSeasonPlayer(userId, seasonId, doc.id).then(() => {
            seasonUndoDoc.players.push(doc)
          }).catch(err => {
            seasonUndoDoc.err = new Error('Error deleting players:' + err.message)
            reject(seasonUndoDoc)
          })
        }
        // delete all schedules
        seasonUndoDoc.schedules = []
        seasonRef.collection('schedules').get().then(async querySnapshot => {
          for (let i = 0; i < querySnapshot.docs.length; i++) {
            const doc = querySnapshot.docs[i]
            await deleteSeasonSchedule(userId, seasonId, doc.id).then(() => {
              seasonUndoDoc.schedules.push(doc)
            }).catch(err => {
              seasonUndoDoc.err = new Error('Error deleting schedules:' + err.message)
              reject(seasonUndoDoc)
            })
          }
          // delete all statistics
          seasonUndoDoc.statistics = []
          seasonRef.collection('statistics').get().then(async querySnapshot => {
            for (let i = 0; i < querySnapshot.docs.length; i++) {
              const doc = querySnapshot.docs[i]
              await deleteSeasonStatistics(userId, seasonId, doc.id).then(() => {
                seasonUndoDoc.schedules.push(doc)
              }).catch(err => {
                seasonUndoDoc.err = new Error('Error deleting statistics:' + err.message)
                reject(seasonUndoDoc)
              })
            }
            seasonRef.get().then(querySnapshot => {
              seasonUndoDoc.season = querySnapshot.data()
              seasonRef.delete().then(() => {
                resolve(seasonUndoDoc)
              }).catch(err => {
                seasonUndoDoc.err = new Error('Error deleting season:' + err.message)
                reject(seasonUndoDoc)
              })
            }).catch(err => {
              seasonUndoDoc.err = new Error('Error deleting season:' + err.message)
              reject(seasonUndoDoc)
            })
          }).catch(function (err) {
            seasonUndoDoc.err = new Error('Error deleting statistics:' + err.message)
            reject(seasonUndoDoc)
          })
        }).catch(function (err) {
          seasonUndoDoc.err = new Error('Error deleting schedules:' + err.message)
          reject(seasonUndoDoc)
        })
      }).catch(err => {
        seasonUndoDoc.err = new Error('Error deleting players:' + err.message)
        reject(seasonUndoDoc)
      })
    }).catch(err => {
      seasonUndoDoc.err = new Error('Error deleting games:' + err.message)
      reject(seasonUndoDoc)
    })
  })
}

export function updateSeasonGame (userId, seasonId, gameId, gameUpdate) {
  return new Promise(async (resolve, reject) => {
    if (gameUpdate.newBroadcast) {
      delete gameUpdate.newBroadcast
      delete gameUpdate.removeBroadcast
      delete gameUpdate.b
      gameUpdate.b = await broadcastGame(userId, seasonId, gameUpdate).then(broadcastId => {
        return broadcastId
      }).catch(err => {
        let newError = Error(err.message)
        console.log(newError.message)
        reject(newError)
      })
    } else {
      delete gameUpdate.newBroadcast
    }
    if (gameUpdate.removeBroadcast && gameUpdate.b !== '') {
      delete gameUpdate.removeBroadcast
      await deleteCollection(broadcastCollection.doc(gameUpdate.b).collection('events')).catch(err => {
        let newError = Error('Error Db_CloudFirestore_updateSeasonGame_broadcast_events_delete failed: ' + err.message)
        console.log(newError.message)
        reject(newError)
      })
      await broadcastCollection.doc(gameUpdate.b).delete().then(() => {
        gameUpdate.b = ''
      }).catch(err => {
        let newError = Error('Error Db_CloudFirestore_updateSeasonGame_broadcast_delete failed: ' + err.message)
        console.log(newError.message)
        reject(newError)
      })
    } else {
      delete gameUpdate.removeBroadcast
    }
    seasonCollection.doc(seasonId).collection('games').doc(gameId).set(gameUpdate, { merge: true }).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateSeasonGame_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createGameStat (userId, seasonId, gameId, gameStat) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('statistics').doc(gameId).set(gameStat).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_createGameStat_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createGameEvent (userId, seasonId, gameId, eventId, event, broadcast) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('games').doc(gameId).collection('events').doc(eventId).set(event).then(() => {
      if (broadcast !== '') {
        broadcastCollection.doc(broadcast).collection('events').doc(eventId).set(event).then(() => {
          resolve()
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_createGameEvent_broadcast_set failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      } else {
        resolve()
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_createGameEvent_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function updateSeason (userId, seasonId, seasonUpdate) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).set(seasonUpdate, { merge: true }).then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_updateSeason_set failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createSeason (userId, season) {
  return new Promise((resolve, reject) => {
    season.roles = {}
    season.roles[userId] = 'owner'
    seasonCollection.add(season).then(docRef => {
      resolve(docRef.id)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_createSeason_add failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getSeasonGame (userId, seasonId, gameId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('games').doc(gameId).get().then(doc => {
      resolve(doc.data())
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonGame_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getSeasonSchedule (userId, seasonId, scheduleId, includeLevels = false) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('schedules').doc(scheduleId).get().then(doc => {
      if (doc.exists) {
        if (includeLevels) {
          let schedule = doc.data()
          let levelsRef = doc.ref.collection('levels')
          levelsRef.orderBy('o').get().then(function (snapshot) {
            let levelsJSON = []
            for (let index = 0; index < snapshot.docs.length; index++) {
              let doc = snapshot.docs[index]
              let docJSON = doc.data()
              docJSON.id = doc.id
              levelsJSON.push(docJSON)
            }
            schedule.levels = levelsJSON
            resolve(schedule)
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_levels_get failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        } else {
          resolve(doc.data())
        }
      } else {
        let newError = Error('Error Db_CloudFirestore_getSeasonSchedule_get failed:  Schedule not found.')
        console.log(newError.message)
        reject(newError)
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonSchedule_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getSeasonPlayer (userId, seasonId, playerId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).collection('players').doc(playerId).get().then(doc => {
      resolve(doc.data())
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonPlayer_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getSeason (userId, seasonId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).get().then(doc => {
      if (doc.exists) {
        resolve(doc.data())
      } else {
        let newError = Error('Error Db_CloudFirestore_getSeason_get failed: Season not found')
        console.log(newError.message)
        reject(newError)
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonPlayer_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function jsonifySeason (seasonId, userId = '', previousVersion = false) {
  return new Promise((resolve, reject) => {
    let seasonRef = null
    if (previousVersion) {
      seasonRef = userCollection.doc(userId).collection('seasons').doc(seasonId)
    } else {
      seasonRef = seasonCollection.doc(seasonId)
    }
    seasonRef.get().then(seasonDoc => {
      if (seasonDoc.exists) {
        let seasonJSON = {}
        seasonJSON = seasonDoc.data()
        delete seasonJSON['roles']
        jsonifySeasonGames(seasonDoc.ref).then(gamesJSON => {
          seasonJSON.games = gamesJSON
          let playersRef = seasonDoc.ref.collection('players')
          jsonifyCollection(playersRef).then(playersJSON => {
            seasonJSON.players = playersJSON
            jsonifySeasonSchedules(seasonDoc.ref).then(schedulesJSON => {
              seasonJSON.schedules = schedulesJSON
              let statisticsRef = seasonDoc.ref.collection('statistics')
              jsonifyCollection(statisticsRef).then(statisticsJSON => {
                seasonJSON.statistics = statisticsJSON
                resolve(seasonJSON)
              }).catch(err => {
                let newError = Error('Error Db_CloudFirestore_jsonifySeason_jsonifyCollection_statistics failed: ' + err.message)
                console.log(newError.message)
                reject(newError)
              })
            }).catch(err => {
              let newError = Error('Error Db_CloudFirestore_jsonifySeason_jsonifySeasonSchedules failed: ' + err.message)
              console.log(newError.message)
              reject(newError)
            })
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_jsonifySeason_jsonifyCollection_players failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_jsonifySeason_jsonifySeasonGames failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      } else {
        let newError = Error('Error Db_CloudFirestore_jsonifySeason failed: Season does not exist.')
        console.log(newError.message)
        reject(newError)
      }
    }).catch(function (err) {
      reject(new Error(err.message))
    })
  })
}

function jsonifySeasonGames (seasonRef) {
  return new Promise((resolve, reject) => {
    seasonRef.collection('games').get().then(async gamesSnapshot => {
      let gamesJSON = []
      for (let index = 0; index < gamesSnapshot.docs.length; index++) {
        let gameDoc = gamesSnapshot.docs[index]
        let gameJSON = gameDoc.data()
        let eventsRef = gameDoc.ref.collection('events')
        gameJSON.id = gameDoc.id
        await jsonifyCollection(eventsRef).then(eventsJSON => {
          gameJSON.events = eventsJSON
          gamesJSON.push(gameJSON)
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_jsonifySeasonGames_jsonifyCollection failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      }
      resolve(gamesJSON)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_jsonifySeasonGames_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

function jsonifySeasonSchedules (seasonRef) {
  return new Promise((resolve, reject) => {
    seasonRef.collection('schedules').get().then(async schedulesSnapshot => {
      let schedulesJSON = []
      for (let index = 0; index < schedulesSnapshot.docs.length; index++) {
        let scheduleDoc = schedulesSnapshot.docs[index]
        let scheduleJSON = scheduleDoc.data()
        let levelsRef = scheduleDoc.ref.collection('levels')
        scheduleJSON.id = scheduleDoc.id
        await jsonifyCollection(levelsRef).then(levelsJSON => {
          scheduleJSON.levels = levelsJSON
          schedulesJSON.push(scheduleJSON)
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_jsonifySeasonSchedules_jsonifyCollection failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      }
      resolve(schedulesJSON)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_jsonifySeasonSchedules_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function getSeasonScheduleList (userId, seasonId) {
  return new Promise((resolve, reject) => {
    let scheduleRef = seasonCollection.doc(seasonId).collection('schedules')
    jsonifyCollection(scheduleRef).then(scheduleJSON => {
      resolve(scheduleJSON)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_getSeasonScheduleList_jsonifyCollection failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function createSeasonScheduleLevels (userId, seasonId, scheduleId, levels) {
  return new Promise((resolve, reject) => {
    let batchLevels = db.batch()
    let levelsRef = seasonCollection.doc(seasonId).collection('schedules').doc(scheduleId).collection('levels')
    for (let i = 0; i < levels.length; i++) {
      let level = levels[i]
      let levelId = level.id
      delete level['id']
      let levelRef = levelsRef.doc(levelId)
      batchLevels.set(levelRef, level)
    }
    batchLevels.commit().then(() => {
      resolve()
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_createSeasonScheduleLevels_commit failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function searchUser (userName) {
  return new Promise((resolve, reject) => {
    let beginSearchString = caseFoldNormalize(userName)
    userCollection.orderBy('name_casefold').where('name_casefold', '>=', beginSearchString).where('name_casefold', '<', endSearchString(beginSearchString)).get().then(querySnapshot => {
      let users = {}
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        users[doc.id] = doc.data().name
      }
      resolve(users)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_searchUser_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function isUserNameInUse (userName, userId) {
  return new Promise((resolve, reject) => {
    let searchString = caseFoldNormalize(userName)
    userCollection.where('name_casefold', '==', searchString).get().then(querySnapshot => {
      let nameInUse = false
      for (let i = 0; i < querySnapshot.docs.length; i++) {
        const doc = querySnapshot.docs[i]
        if (doc.id !== userId) {
          nameInUse = true
          break
        }
      }
      resolve(nameInUse)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_isUserNameInUse failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

export function addSeasonReader (userId, seasonId) {
  return new Promise((resolve, reject) => {
    seasonCollection.doc(seasonId).get().then(doc => {
      if (doc.exists) {
        let seasonDoc = doc.data()
        if (!Object.keys(seasonDoc.roles).includes(userId)) {
          let newRole = {}
          newRole['roles.' + userId] = 'reader'
          seasonCollection.doc(seasonId).update(newRole).then(() => {
            resolve()
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_addSeasonReader_update failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        } else {
          let newError = Error('Error Db_CloudFirestore_addSeasonReader failed: User already has a role.')
          console.log(newError.message)
          reject(newError)
        }
      } else {
        let newError = Error('Error Db_CloudFirestore_addSeasonReader failed: Season does not exist.')
        console.log(newError.message)
        reject(newError)
      }
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_addSeasonReader_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

function deleteCollection (collectionRef) {
  var query = collectionRef.orderBy('__name__').limit(batchSize)
  var undoDocs = []
  return new Promise((resolve, reject) => {
    deleteQueryBatch(query, resolve, reject, undoDocs)
  })
}

function deleteQueryBatch (query, resolve, reject, undoDocs) {
  query.get()
    .then((snapshot) => {
      // When there are no documents left, we are done
      if (snapshot.size === 0) {
        return 0
      }

      // Delete documents in a batch
      var batch = db.batch()
      for (let i = 0; i < snapshot.docs.length; i++) {
        const doc = snapshot.docs[i]
        undoDocs.push(doc.data())
        batch.delete(doc.ref)
      }

      return batch.commit().then(() => {
        return snapshot.size
      })
    }).then((numDeleted) => {
      if (numDeleted === 0) {
        resolve(undoDocs)
        return
      }

      // Recurse on the next process tick, to avoid
      // exploding the stack.
      process.nextTick(() => {
        deleteQueryBatch(query, resolve, reject, undoDocs)
      })
    }).catch((err) => {
      if (err.hasOwnProperty('err')) {
        reject(err)
      } else {
        undoDocs.err = err
        reject(undoDocs)
      }
    })
}

function jsonifyCollection (collectionRef) {
  return new Promise((resolve, reject) => {
    collectionRef.get().then(function (snapshot) {
      let docsJSON = []
      for (let index = 0; index < snapshot.docs.length; index++) {
        let doc = snapshot.docs[index]
        let docJSON = doc.data()
        docJSON.id = doc.id
        docsJSON.push(docJSON)
      }
      resolve(docsJSON)
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_jsonifyCollection_get failed: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

function broadcastGame (userId, seasonId, gameUpdate) {
  return new Promise((resolve, reject) => {
    let game = {}
    let key
    for (key in gameUpdate) {
      if (gameUpdate.hasOwnProperty(key) && key !== 'players' && key !== 'e') {
        game[key] = gameUpdate[key]
      }
    }

    getSeasonSchedule(userId, seasonId, game.s, true).then(schedule => {
      delete schedule.n
      delete schedule.id

      let key
      for (key in schedule) {
        if (schedule.hasOwnProperty(key)) {
          if (key === 'levels') {
            game['ll'] = schedule['levels']
          } else {
            game[key] = schedule[key]
          }
        }
      }
      game.c = fieldValue.serverTimestamp()
      getSeason(userId, seasonId).then(season => {
        game.gpo = season.gpo
        game.r = season.r
        game.t = season.t
        seasonCollection.doc(seasonId).collection('players').orderBy('n').get().then(snapshot => {
          game.pl = []
          for (let i = 0; i < snapshot.docs.length; i++) {
            const doc = snapshot.docs[i]
            let player = {}
            let data = doc.data()
            if (gameUpdate.players.includes(doc.id)) {
              player.id = doc.id
              player.n = data.n
              game.pl.push(player)
            }
          }
          broadcastCollection.add(game).then(docRef => {
            resolve(docRef.id)
          }).catch(err => {
            let newError = Error('Error Db_CloudFirestore_broadcastGame_add failed: ' + err.message)
            console.log(newError.message)
            reject(newError)
          })
        }).catch(err => {
          let newError = Error('Error Db_CloudFirestore_broadcastGame_get failed: ' + err.message)
          console.log(newError.message)
          reject(newError)
        })
      }).catch(err => {
        let newError = Error('Error Db_CloudFirestore_broadcastGame: ' + err.message)
        console.log(newError.message)
        reject(newError)
      })
    }).catch(err => {
      let newError = Error('Error Db_CloudFirestore_broadcastGame: ' + err.message)
      console.log(newError.message)
      reject(newError)
    })
  })
}

const database = {
  user: {
    setStatus: setUserStatus,
    get: getUser,
    deleteName: deleteUserName,
    update: updateUser,
    search: searchUser,
    isNameInUse: isUserNameInUse
  },
  season: {
    addPlayer: addSeasonPlayer,
    updatePlayer: updateSeasonPlayer,
    deletePlayer: deleteSeasonPlayer,
    incrementMaxId: incrementSeasonMaxId,
    deleteStatistics: deleteSeasonStatistics,
    createSnapshot: createSeasonSnapshot,
    createSharedSnapshot: createSharedSeasonSnapshot,
    createPlayersSnapshot: createSeasonPlayersSnapshot,
    createSchedulesSnapshot: createSeasonSchedulesSnapshot,
    createStatsSnapshot: createSeasonStatsSnapshot,
    createGamesSnapshot: createSeasonGamesSnapshot,
    getScheduleLevels: getSeasonScheduleLevels,
    updateSchedule: updateSeasonSchedule,
    updateScheduleLevels: updateSeasonScheduleLevels,
    deleteSchedule: deleteSeasonSchedule,
    deleteGame: deleteSeasonGame,
    delete: deleteSeason,
    updateGame: updateSeasonGame,
    update: updateSeason,
    create: createSeason,
    getGame: getSeasonGame,
    getSchedule: getSeasonSchedule,
    getPlayer: getSeasonPlayer,
    get: getSeason,
    jsonify: jsonifySeason,
    getScheduleList: getSeasonScheduleList,
    createScheduleLevels: createSeasonScheduleLevels,
    getPreviousVersionList: getPreviousVersionSeasonList,
    deleteReader: deleteSeasonReader,
    addReader: addSeasonReader
  },
  game: {
    deleteEvent: deleteGameEvent,
    createGamesSnapshot: createGameGamesSnapshot,
    createEventsSnapshot: createGameEventsSnapshot,
    createTimerGameSnapshot: createGameTimerGameSnapshot,
    createStat: createGameStat,
    createEvent: createGameEvent
  },
  utils: {
    jsonifyCollection: jsonifyCollection
  }
}

export default database
